import moment from "moment";
import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import Api from "../../../../../../initialpage/hooks/Api";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
const toBn = (n) => n?.replace(/\d/g, (d) => "০১২৩৪৫৬৭৮৯"[d]);
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const ViewRecentMrr = () => {
  const navigate = useNavigate();
  const { info } = useParams();
  const myArray = info.split("&");
  //console.log(myArray[0], myArray[1], myArray[2]);

  // get doneReqSlip Data
  const {
    data: viewMrrSlip,
    error,
    mutate,
  } = useSWR(
    myArray[1] && myArray[0] && myArray[2]
      ? `store/mrr/productrecept/${myArray[1]}/${myArray[0]}/${myArray[2]}`
      : null,
    fetcher
  );

  console.log(viewMrrSlip);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <Helmet>
        <title>Requisition Details - BBA STORE</title>
        <meta name="description" content="Requisition Details - BBA STORE" />
      </Helmet>
      {!viewMrrSlip ? (
        <NotFoundPage />
      ) : (
        <div className="page-wrapper">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                class="btn btn-o ms-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div>
              <Link to={`/editproductreceipt/${info}`}>
                <button
                  type="button"
                  className="btn btn-color_store px-3  show ms-auto  me-2 "
                >
                  <i class="fa fa-pen-to-square"></i>
                  <span> Edit</span>
                </button>
              </Link>

              <button
                onClick={handlePrint}
                type="button"
                className="btn btn-danger px-3 printBtn show ms-auto  me-2 "
              >
                <i className="fa fa-print"></i>
                <span> Print</span>
              </button>
            </div>
          </div>

          <section ref={componentRef} className=" mx-3 py-4">
            <div className="my-5">
              <>
                <div className="row">
                  <div className="col-3 col-md-4 col-lg-3"></div>
                  <div className="col-6 col-md-6 col-lg-6 "></div>
                  <div className="col-3 col-md-2 col-lg-3 text-end">
                    <h4>এন্ট্রি নং: {toBn(`${myArray[0]}`)}</h4>
                  </div>
                </div>

                <div className="text-center mt-3">
                  <h4>
                    <b>INFOTECH IT SOLUTIONS</b>
                  </h4>

                  <h3>দ্রব্য প্রাপ্তির রসিদ (MRR)</h3>
                </div>

                <div className=" px-2 mt-5 py-4 d-flex justify-content-between">
                  <div>
                    <h4 className="mb-3">
                      সরবরাহকারী : {viewMrrSlip.suppliers[0].supplier}
                    </h4>
                    <h4>
                      কার্যাদেশ সংখ্যা:
                      {toBn(viewMrrSlip.entriesInfo.workorder)}{" "}
                    </h4>
                    <h4>
                      ক্যাশ মেমো / বিল / চালান নং:{" "}
                      {toBn(viewMrrSlip.entriesInfo.cashmemono?.split(" ")[0])}{" "}
                    </h4>
                  </div>
                  <div>
                    <h4 className="mb-3">
                      তারিখ :
                      {toBn(
                        moment(
                          new Date(viewMrrSlip.entriesInfo.SUPPDATE)
                        ).format("DD/MM/YYYY")
                      )}
                    </h4>
                    <h4>
                      তারিখ :
                      {toBn(
                        moment(
                          new Date(viewMrrSlip.entriesInfo.WORKODATE)
                        ).format("DD/MM/YYYY")
                      )}
                    </h4>
                    <h4>
                      তারিখ :
                      {toBn(
                        moment(
                          new Date(viewMrrSlip.entriesInfo.CASHMEMODATE)
                        ).format("DD/MM/YYYY")
                      )}
                    </h4>
                  </div>
                </div>
              </>

              <div className="px-2 my-5">
                <table className="table ">
                  <thead>
                    <tr>
                      <th className="fw-bold col-design">ক্রমিক নং</th>
                      <th className="fw-bold col-design">বিবরণ</th>
                      <th className="fw-bold col-design">ইউনিট</th>
                      <th className="fw-bold col-design"> পরিমাণ</th>
                      <th className="fw-bold col-design">একক মূল্য</th>
                      <th className="fw-bold col-design">টাকার পরিমাণ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewMrrSlip?.entriLists &&
                      viewMrrSlip?.entriLists.map((product, index) => (
                        <tr key={index}>
                          <td className="col-design">{toBn(`${++index}`)}</td>
                          <td className="col-design text-start ps-1">
                            {product?.proname}
                          </td>
                          <td className="col-design">{product?.unit}</td>
                          <td className="col-design">
                            {toBn(`${parseInt(product?.quantities)}`)}
                          </td>
                          <td className="col-design">
                            {toBn(`${parseInt(product?.proamount)}`)}
                          </td>
                          <td className="col-design">
                            {toBn(
                              `${product?.quantities * product?.proamount}`
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  <tbody>
                    {viewMrrSlip && (
                      <tr>
                        <td className="col-design"></td>
                        <td className="col-design"></td>
                        <td className="col-design total-design">
                          মোট দ্রব্যর পরিমাণ
                        </td>
                        <td className="col-design fw-bold">
                          {toBn(`${viewMrrSlip?.totalQuantities}`)}
                        </td>
                        <td className="col-design total-design">
                          মোট টাকার পরিমাণ
                        </td>
                        <td className="col-design fw-bold">
                          {toBn(`${viewMrrSlip?.totalProAmount}`)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div>
                <h5 className="text-center">
                  উপরে উল্লেখিত মালগুলি গৃহীত হইল । সংযুক্ত বিল/ক্যাশ মেমোর টাকা
                  পরিশোধ /সমন্বয় করা যাইতে পারে ।
                </h5>
              </div>

              <div className=" px-2 py-5 row mt-5">
                <div className="col-4 col-md-4 col-lg-4">
                  <h5 className="text-start">
                    <span className="fw-bold">স্টোর কিপার</span>
                  </h5>
                </div>
                <div className="col-4 col-md-4 col-lg-4 text-center ">
                  <h5>
                    <span className="fw-bold">স্টোর অফিসার </span>
                  </h5>
                </div>
                <div className="col-4 col-md-4 col-lg-4 text-end">
                  <h5 className="text-end">
                    <span className="fw-bold">সহকারী পরিচালক (প্রঃ)</span>
                  </h5>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default ViewRecentMrr;
